import type { ReactNode } from "react";

import { Stack, type StackProps } from "@braintrust/braintrust-ui-components";

type AIInterviewInfoAlertProps = {
  text: ReactNode;
  action?: ReactNode;
} & Pick<StackProps, "sx">;

export const AIInterviewInfoAlert = ({
  text,
  action,
  sx,
}: AIInterviewInfoAlertProps) => {
  return (
    <Stack
      direction="row"
      sx={{
        gap: 2,
        justifyContent: "space-between",
        px: 2,
        py: 1,
        backgroundColor: "var(--positive-3)",
        alignItems: "center",
        borderRadius: 1,
        minHeight: "48px",
        ...sx,
      }}
    >
      {text}
      {action}
    </Stack>
  );
};
